export const MIN_POOL_COMMISSION = 0;

export const DEFAULT_POOL_PPS_COMMISSION = 0.04;
export const DEFAULT_POOL_PPLNS_COMMISSION = 0.02;
